(function () {
  function updateCount(cart) {
    var countEl = document.querySelector('[data-dp-floating-cart-count]');
    if (!countEl) return;
    countEl.textContent = cart.item_count;
    countEl.hidden = cart.item_count === 0;
  }

  document.addEventListener('shopify:cart:lines-update', function (e) {
    if (e.promise) {
      e.promise.then(function (result) {
        if (result && result.cart) updateCount(result.cart);
      }).catch(function () {});
    }
  });
})();